import { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import Table from "../../components/Table";
import api from "../../api";

const movementTypeLabels = {
    in_total: "Ingreso a stock total",
    assign_to_or: "Asignación a quirófano",
    return_from_or: "Devolución desde quirófano",
    out_or: "Salida de quirófano",
    adjust_total: "Ajuste de stock total",
    adjust_or: "Ajuste de quirófano",
};

export function MovementsPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [movements, setMovements] = useState([]);
    const [supplyNames, setSupplyNames] = useState({});

    const columns = [
        {
            name: "supply",
            displayText: "Insumo",
            render: (row) => supplyNames[row.supply] || row.supply,
        },
        {
            name: "movementType",
            displayText: "Movimiento",
            render: (row) => movementTypeLabels[row.movementType] || row.movementType,
        },
        { name: "quantity", displayText: "Cantidad" },
        { name: "performedBy", displayText: "Realizado por" },
        { name: "notes", displayText: "Notas" },
        { name: "createdAt", displayText: "Fecha" },
    ];

    useEffect(() => {
        api.supplies.getMulti().then((response) => {
            const names = {};
            (response.data || []).forEach((s) => {
                names[s.id] = s.category;
            });
            setSupplyNames(names);
        });
        api.stockMovements
            .getMulti("-createdAt")
            .then((response) => {
                setMovements(response.data || response);
                setLoading(false);
            })
            .catch((e) => {
                setError(e.detail || "No se pudieron cargar los movimientos");
                setLoading(false);
            });
    }, []);

    return (
        <div className="bg-gray-100 h-screen">
            <Sidebar
                currentScreen={"Insumos"}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <div className="md:pl-64 flex flex-col h-screen flex-1">
                <Header setSidebarOpen={setSidebarOpen} />
                <main className="flex-1 space-y-6 bg-gray-100 py-8 px-6 lg:px-8">
                    <h2 className="text-gray-600 text-4xl font-bold">
                        Movimientos de stock
                    </h2>
                    {loading ? (
                        <div className="flex h-full items-center justify-center ">
                            <div className="w-16 h-16 border-b-2 border-blue-900 rounded-full animate-spin"></div>
                        </div>
                    ) : error ? (
                        <p className="text-red-600">{error}</p>
                    ) : (
                        <Table module="supplies" columns={columns} rows={movements} />
                    )}
                </main>
            </div>
        </div>
    );
}
